import React, { useState, useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomCheckbox from '~/components/CustomCheckbox/CustomCheckbox';

//utils
import { getDayColor, getDayBgColor } from '~/utils/rosterMethods';

const DayCard = ({ day, dayDate, isRosterPublished, isHoliday, holidayDetails, dayLabel, isFixedInOtherWeeks, isFixedInThisWeek, isDisabled, weekData, companyShifts, handleShiftSelect, handleDayToggle, addHelperText, allowStandbyCalls }) => {
    const [activeTab, setActiveTab] = useState('WS');

    const { tabShifts, tabCounts } = useMemo(() => {
        const ws = [], fc = [], sb = [];
        let wsBadge = 0, fcBadge = 0, sbBadge = 0;
        const dayData = weekData[day.key];

        for (const s of companyShifts) {
            const isSelected = dayData?.shiftCodeId === s.id || dayData?.fCodeId === s.id || dayData?.standbyCodeId === s.id;
            if (s.shift_type === 'freeShift') {
                fc.push(s);
                if (isSelected) fcBadge++;
            } else if (s.shift_type === 'standbyShift') {
                sb.push(s);
                if (isSelected) sbBadge++;
            } else {
                ws.push(s);
                if (isSelected) wsBadge++;
            }
        }

        return {
            tabShifts: { WS: ws, FC: fc, SB: sb },
            tabCounts: { WS: wsBadge, FC: fcBadge, SB: sbBadge },
        };
    }, [companyShifts, weekData, day.key]);

    const showFC = tabShifts.FC.length > 0;
    const showSB = !!allowStandbyCalls;

    const visibleTabs = ['WS', showFC && 'FC', showSB && 'SB'].filter(Boolean);

    const resolvedTab = visibleTabs.includes(activeTab) ? activeTab : 'WS';
    const activeShifts = tabShifts[resolvedTab];
    const dayData = weekData[day.key];

    return (
        <div key={day.key} className="col-12 col-md-6 col-lg-4 mb-4">
            <div className={`weekly-shift-day-card ${getDayBgColor(day.key, isHoliday)} ${isDisabled ? 'weekly-shift-day-card-disabled' : ''}`}>
                <div className={`d-flex justify-content-between align-items-center p-2 weekly-shift-day-header ${getDayColor(day.key, isHoliday)}`}>
                    <span className="fw-bold fs15 d-flex align-items-center gap-2">
                        {dayLabel}
                        <>
                            {isHoliday && (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>{holidayDetails?.custom_name || holidayDetails?.name}</Tooltip>}
                                >
                                    <i className="fa fa-info-circle fs-12 cursor-pointer" />
                                </OverlayTrigger>
                            )}
                            {addHelperText && (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>{addHelperText}</Tooltip>}
                                >
                                    <span>⛔</span>
                                </OverlayTrigger>
                            )}
                        </>
                    </span>
                    <div className="weekly-shift-day-checkbox">
                        <CustomCheckbox
                            isChecked={isFixedInOtherWeeks || isFixedInThisWeek}
                            onChange={() => !isDisabled && handleDayToggle(day.key, dayDate, day.dayName)}
                            disabled={isRosterPublished || isDisabled || !dayData?.shiftCodeId}
                        />
                    </div>
                </div>

                <div className="d-flex" style={{ borderBottom: '1px solid #dee2e6', paddingLeft: '0.9rem', paddingRight: '0.9rem' }}>
                    {visibleTabs.map(tabKey => (
                        <button
                            key={tabKey}
                            onClick={() => setActiveTab(tabKey)}
                            className="d-flex align-items-center gap-1 border-0 bg-transparent px-3 py-2 fs-12 fw-bold cursor-pointer"
                            style={{
                                borderBottom: resolvedTab === tabKey ? '2px solid #0d6efd' : '2px solid transparent',
                                color: resolvedTab === tabKey ? '#0d6efd' : '#6c757d',
                                marginBottom: '-1px',
                            }}
                        >
                            {tabKey}
                            <span
                                className="badge rounded-pill ms-1"
                                style={{
                                    backgroundColor: tabCounts[tabKey] > 0 ? '#0d6efd' : '#dee2e6',
                                    color: tabCounts[tabKey] > 0 ? '#fff' : '#6c757d',
                                    fontSize: '10px',
                                }}
                            >
                                {tabCounts[tabKey]}
                            </span>
                        </button>
                    ))}
                </div>

                <div className="d-flex flex-wrap gap-2" style={{ padding: '0.9rem' }}>
                    {activeShifts.map((companyShift, idx) => {
                        const isSelected = dayData?.shiftCodeId === companyShift?.id || dayData?.fCodeId === companyShift?.id || dayData?.standbyCodeId === companyShift?.id;
                        return (
                            <div
                                key={`shift-${idx}`}
                                onClick={() => !isDisabled && handleShiftSelect(day.key, companyShift, dayDate)}
                                style={{ backgroundColor: !isSelected && companyShift?.shift_color ? companyShift?.shift_color : '' }}
                                className={`fs-12 d-flex justify-content-center align-items-center weekly-shift-code-button ${isSelected ? 'weekly-shift-code-button-selected' : ''} ${isDisabled ? 'weekly-shift-code-button-disabled' : ''}`}
                                title={`${companyShift?.short_code}`}
                            >
                                <div className={`${companyShift?.short_code ? companyShift?.short_code.split(' ').length - 1 > 1 ? "overflow-hidden text-overflow text-nowrap" : "" : ""} `} style={{ width: '50px' }}>
                                    {companyShift?.short_code}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default DayCard;
